export default __webpack_public_path__ + "static/media/sample-passport-data-page.3ac253a3.png";